//This is for POS Print

import React from "react";
import "./stylePos.css";
import { currecy, currency } from "../../../../MUI_components/currencyFormatterTag"
import { useSelector } from "react-redux";
import { company } from "titum-custom/details";
import BillHeader from "Components/Print/billHeaderPos";
import { bottomNavigationActionClasses } from "@mui/material";
import { VerticalAlignBottom } from "@mui/icons-material";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";

const PrintBill = React.forwardRef((props, ref) => {
  const { code, date } = useSelector((state) => state.lastInsertInvoice);
  const printedDate = date ? new Date(date) : new Date();
  const {returnedDiscount,submittedData} = props;
  const { customer, invoice, stockHistories } = submittedData;
  const discount = parseFloat(returnedDiscount);

  //Stock History Level
  const handleLineTotal = (qty, price, discountPer, discountAmount) => {
    let totalAmount = qty * price;
    discountAmount = discountAmount * qty;
    let lineTotalAmount = totalAmount - totalAmount * (discountPer / 100) - discountAmount;
    return lineTotalAmount;
  };

  // const returnedTotal = returnData ? returnData
  //   .map((total) => total.totalAmount)
  //   .reduce((prev, curr) => prev + curr, 0) : ""

  return (

    <div className ref={ref}>

      <div className="billBody" >
        <BillHeader />

        <div className="text-center " style={{ fontSize: 12 }}>
          <div style={{ textAlign: "center", fontSize: 12 }}>{company.address}</div>
          <div style={{ textAlign: "center", fontSize: 12 }} >TEL: {company.phone} / {company.phone2} </div>
        </div>

        <div style={{ borderTop: "1px solid #000", marginBottom: 2 }} ></div>
        <div align="center">
          <strong>{`SALES RETURN : - ${submittedData.code}`}</strong>
        </div>

        <div >
        {/* <div className="flex" >
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.SALES_RETURN_CODE}:</strong> &nbsp;
            <strong style={{ fontSize: 11 }}>   {submittedData.code}</strong>
          </div> */}
          <div className="flex" >
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.INVOICE_NUMBER}:</strong> &nbsp;
            <strong style={{ fontSize: 11 }}>   {invoice ? invoice.code : ""}</strong>
          </div>

          <div className="flex" >
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.CUSTOMER_NAME}: </strong>&nbsp;
            <strong style={{ fontSize: 11 }}>{customer ? customer.firstName : ""} </strong>
          </div>

          <div className="flex" >
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.DATE}: </strong>&nbsp;
            <strong style={{ fontSize: 11 }}>{printedDate.toLocaleString()}</strong>
          </div>
        </div>

        <div style={{ borderBottom: "1px solid #000", marginTop: 2 }}></div>

        <table className="print-table-pos">
          <thead className="thead">
            <tr style={{ borderBottom: "1px solid #000" }}>
              <th width="">#</th>
              <th align="left" >{COLUMNS_NAME.DESCRIPTION}</th>
              <th align="right"  style={{ paddingLeft: 10 }}>{COLUMNS_NAME.QUANTITY}</th>
              <th align="right"  style={{ paddingLeft: 10 }} >{COLUMNS_NAME.UNIT_SOLD_PRICE}</th>
              <th align="right"  style={{ paddingLeft: 10 }} >{COLUMNS_NAME.TOTAL}</th>
            </tr>
      
          </thead>

          <tbody>
            {stockHistories?.filter(i => i.quantity > 0)
              .map((row, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td> {index + 1}.</td>
                    <td colSpan="5">
                      {row.name ? row.name : row.itemMaster.name}

                    </td>
                  </tr>
                  <tr>
                    <td colSpan="2" align="right" ><strong>{parseFloat(row.quantity)}</strong> </td>
                    <td colSpan="2" align="right">{currency(row.unitSoldPrice  ? row.unitSoldPrice : row.retailPrice )}</td>
                    <td colSpan="2" align="right">{currency(row.totalAmount)}</td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>

        </table>


        <div style={{ borderBottom: "1px solid #000" }}></div>

        <div
          className="flex-print  mb  justify-content-spaceBetween"
     
        >
          <strong style={{ fontSize: 16 }}>{COLUMNS_NAME.TOTAL} :</strong>

          <strong style={{ fontSize: 16 }}>{currency(submittedData.totalAmount + discount)}</strong>
        </div>

      

<div
  className="flex-print  mb  justify-content-spaceBetween"
  style={{ borderTop: "1px solid #000" }}
>
  <strong style={{ fontSize: 16 }}>{COLUMNS_NAME.DISCOUNT} :</strong>

  <strong style={{ fontSize: 16 }}>{currency(discount)}</strong>
</div>

<div style={{ borderBottom: "1px solid #000" }}></div>

<div
  className="flex-print  mb  justify-content-spaceBetween"
  
>
  <strong style={{ fontSize: 16 }}>{COLUMNS_NAME.LAST_TOTAL} :</strong>

  <strong style={{ fontSize: 16 }}>{currency(submittedData.totalAmount)}</strong>
</div>



        <div style={{ borderBottom: "1px solid #000" }}></div>

        {/* PRINT WITH BIZX FOOTER */}
        {/* <small className="mt  text-center" >

          <div style={{ fontSize: 11 }} >
            ITEMS PURCHASED WILL NOT BE RETURNED OR EXCHANCED AFTER 14 DAYS & ELECTRICAL ITEMS WILL NOT BE ACCEPTED.<br />
            **CASH WILL NOT BE REFUNDED**<br />
            CREDIT BILLS SHOULD BE SETTLED  WITHIN 30 DAYS FROM THE DATE OF ISSUE.<br />
            THANK YOU COME AGAIN <br />
            SOLUTION BY TITUM (PVT) LTD <br />
            {TitumDetails.WEB} | {TitumDetails.EMAIL_ID}

          </div>
        </small> */}
      </div>

    </div>
  )
});

export default PrintBill;

// mt-margin top mb-marigin bottom
// justify-content-spaceBetween - vertical space
// #000 - black